<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading">
      {{ $t("loadingTxt") }}...
    </div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">
      <!--begin::sidebar-->
      <sidebar-component classMenu="TemplateSetting"></sidebar-component>
      <!--end::sidebar-->

      <div class="page-wrapper">
        <!--begin::navbar-->
        <navbar-component></navbar-component>
        <!--end::navbar-->
        <!--begin::content-->
        <div class="page-content">
          <!-- <div
            class="d-flex justify-content-between align-items-center flex-wrap grid-margin"
          >
            <div>
              <h4 class="mb-3 mb-md-0">Template PI</h4>
            </div>
          </div> -->
          <div class="d-flex justify-content-between align-items-center flex-wrap grid-margin">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <h4 class="float-start">Template PI</h4>
                  <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                    style="margin-right: 5px" @click.prevent="createData()">
                    <i class="link-icon" data-feather="plus"></i>
                    {{ $t("createNew") }}
                  </button>
                </div>
                <div class="card-body">
                  <vue-good-table title="list-region" mode="remote" @on-page-change="onPageChange"
                    @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :line-numbers="true"
                    :isLoading.sync="isLoading" :pagination-options="{
                      enabled: true,
                    }" :rows="rows" :columns="columns">
                    <template slot="table-row" slot-scope="props">
                      <span v-if="props.column.field == 'actions'">
                        <template>
                          <a href="#" v-if="permision_role.method_read" title="Detail"
                            @click.prevent="detailData(props.index, props.row)">
                            <i class="mdi mdi-eye" style="font-size: 16px"></i>
                          </a>
                          <a href="#" v-if="permision_role.method_update && props.row.is_used != 1" title="Edit"
                            @click.prevent="editData(props.index, props.row)">
                            <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                          </a>
                          <a href="#" v-if="permision_role.method_update" title="Download" @click.prevent="
                            downloadTemplate(props.index, props.row)
                            ">
                            <i class="mdi mdi-download" style="font-size: 16px"></i>
                          </a>
                          <a href="#" v-if="permision_role.method_update" title="Copy" @click.prevent="
                            duplicateTemplate(props.index, props.row)
                            ">
                            <i class="mdi mdi-content-copy" style="font-size: 16px"></i>
                          </a>

                          <a href="#" v-if="permision_role.method_custom1" title="Delete"
                            @click.prevent="deleteData(props.index, props.row)">
                            <i class="mdi mdi-trash-can-outline" style="font-size: 16px"></i>
                          </a>
                        </template>
                      </span>
                      <span v-else-if="props.column.field == 'companyName'">
                        {{ props.row.company?.name }}
                      </span>
                      <span v-else-if="props.column.field == 'companySapCode'">
                        {{ props.row.company?.sap_code }}
                      </span>

                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
export default {
  name: "TemplateSettingIndex",
  props: {},
  components: {
    sidebarComponent,
    navbarComponent,
    footerComponent,
  },
  computed: {
    columns() {
      return [
        {
          label: "Customer Name",
          field: "companyName",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "SAP Code",
          field: "companySapCode",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Template Name",
          field: "template_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Description",
          field: "description",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Created By",
          field: "created_by",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Created At",
          field: "created_at",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter",
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Action",
          field: "actions",
        },
      ];
    },
  },
  data() {
    return {
      closeBtn: true,
      permision_role: [],
      isLoading: false,
      errors: [],
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
    };
  },
  watch: {},
  methods: {
    detailData(index, row) {

      var params = this.$onRandom(row.proforma_invoice_template_header_id);
      window.location.href = "/proforma-invoice/template-setting/detail/" + params;
    },
    downloadTemplate(index, row) {
      const baseURI =
        this.$settings.endPointProformaInvoice +
        "v1/template-pi/preview-download/" +
        row.proforma_invoice_template_header_id;
      var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
      var file_name = "download_" + CurrentDate + ".xlsx";

      //var columnFilters = this.serverParams.columnFilters;
      this.fade(true);
      return this.$http
        .get(baseURI, {
          responseType: "blob",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.fade(false);
        })
        .finally(() => {
          this.loading();
        });
    },
    duplicateTemplate(index, row) {
      var params = this.$onRandom(row.proforma_invoice_template_header_id);
      window.location.href = "/proforma-invoice/template-setting/add?id=" + params;
    },
    createData() {
      window.location.href = "/proforma-invoice/template-setting/add";
    },
    editData(index, row) {
      var params = this.$onRandom(row.proforma_invoice_template_header_id);
      window.location.href = "/proforma-invoice/template-setting/edit/" + params;
    },
    deleteData(index, data) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: this.$t("yourDataDelete"),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          this.fade(true);
          const baseURI =
            this.$settings.endPointProformaInvoice +
            "v1/template-pi/delete/" +
            data.proforma_invoice_template_header_id;

          this.$http
            .delete(baseURI)
            .then((response) => {
              if (response.data.status === 200) {
                this.success("Success");
                this.loadItems();
                return true;
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
                return false;
              }
             
            })
            .catch((error) => {
              if (error.response) {
                if (error.response.status === 422) {
                  this.errors = error.response.data.errors;
                  this.resultError(error.response.data.errors);
                } else if (error.response.status === 500) {
                  this.$router.push("/server-error");
                } else {
                  this.$router.push("/page-not-found");
                }
              }
              this.fade(false);
              return false;
            });
        }
      });
    },
    loadItems() {
      const baseURI =
        this.$settings.endPointProformaInvoice + "v1/template-pi/index";

      const queryParams = {
        limit: this.serverParams.per_page,
        page: this.serverParams.page,
        sort_field: this.serverParams.sort.field,
        sort_type: this.serverParams.sort.type,
        ...this.serverParams.columnFilters,
      };

      // Clean up params: remove undefined, null, or empty string
      Object.keys(queryParams).forEach((key) => {
        if (
          queryParams[key] === undefined ||
          queryParams[key] === null ||
          queryParams[key] === ""
        ) {
          delete queryParams[key];
        }
      });

      return this.$http
        .get(baseURI, { params: queryParams })
        .then((response) => {
          this.rows = response.data.datas.data;
          this.totalRecords = response.data.datas.total;
        });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      this.loadItems();
    },

    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "TemplatePIController") {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }
      this.permision_role = rolePermision;
    },
    fade(type) {
      this.isLoading = type;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.isLoading = false;
      }, 1000); // hide the message after 3 seconds
    },
    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  mounted() {
    this.fetchIt();
  },
  created() { },
};
</script>
<style></style>
